import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  CONTRACT_TYPE_OPTIONS,
  ContractType,
} from '@/pages/instruments/new-instrument/constants/contract-types'

type AssetIdentifier = Exclude<ContractType, 'Digital'>

export interface AssetIdentifierFormFieldProps {}

export const AssetIdentifierFormField: React.FC<AssetIdentifierFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{
    asset_identifier: Uppercase<AssetIdentifier>
  }>()

  return (
    <FormField
      name="asset_identifier"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Asset Identifier</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value?.toString()}
              setValue={(value) =>
                setValue('asset_identifier', value as Uppercase<AssetIdentifier>, {
                  shouldValidate: true,
                })
              }
              options={CONTRACT_TYPE_OPTIONS.filter((v) => v.value !== 'Digital')}
              placeholder={'Enter an asset identifier'}
            />
          </FormItem>
        )
      }}
    />
  )
}
